import { render, staticRenderFns } from "./MyThesisList.vue?vue&type=template&id=64905309&scoped=true&"
import script from "./MyThesisList.vue?vue&type=script&lang=js&"
export * from "./MyThesisList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64905309",
  null
  
)

export default component.exports